/** Default drei/three `TransformControls` size is 1. */
export const KEY_POSE_TRANSFORM_CONTROLS_SIZE = 1.4;
